import PropTypes from 'prop-types'
import PreviewBarLeft from './PreviewBarLeft'
import PreviewBarRight from './PreviewBarRight'

/**
 * Custom `PreviewBar` component declaration.
 * Integration of components PreviewBarLeft and PreviewBarRight.
 * @param {Function} onPageUp
 * @param {Function} onRotate
 * @param {Function} onPageDown
 * @param {Function} onDownloadWord
 * @param {Function} onDownload
 * @param {Function} changeStateWatermark
 * @param {Function} totalPages
 * @param {Function} currentPage
 * @param {Function} hidden
 * @return PreviewBar
 */
const PreviewBar = (props: any) => {
  // if (props.hidden) {
  //   return null
  // }
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2vh' }}>
      <PreviewBarLeft
        onPageUp={props.onPageUp}
        onPageDown={props.onPageDown}
        totalPages={props.totalPages}
        currentPage={props.currentPage}
        hidden={props.hidden}
      />

      <PreviewBarRight
        onRotate={props.onRotate}
        onDownload={props.onDownload}
        onDownloadWord={props.onDownloadWord}
        changeStateWatermark={props.changeStateWatermark}
        hidden={props.hidden}
      />
    </div>
  )
}

PreviewBar.propTypes = {
  onPageUp: PropTypes.func.isRequired,
  onRotate: PropTypes.func.isRequired,
  onPageDown: PropTypes.func.isRequired,
  onDownloadWord: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  changeStateWatermark: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  hidden: PropTypes.bool,
}

export default PreviewBar